import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  detailVehicleHistory,
  listVehiclesHistory,
  vehicleHistoryPorto,
} from './VehiclesHistory.service';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  VehicleHistoryDetailQuery,
  VehicleHistoryPortoRequest,
  VehicleHistoryQuery,
} from './VehiclesHistory.types';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { queryClient } from '@/Root';

const QUERY_VEHICLE_HISTORY = 'vehicles-history';
const QUERY_VEHICLE_HISTORY_PORTO = 'vehicles-history/porto';

export function useVehiclesHistory(params?: VehicleHistoryQuery) {
  const query = useInfiniteQuery(
    [QUERY_VEHICLE_HISTORY, params],
    ({ pageParam }) => {
      const req: VehicleHistoryQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listVehiclesHistory(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useVehicleHistoryDetail() {
  const mutation = useMutation((params: VehicleHistoryDetailQuery) =>
    detailVehicleHistory(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useVehicleHistoryDetailQuery(
  params?: VehicleHistoryDetailQuery,
) {
  const mutation = useQuery(['history-detail', { ...params }], () =>
    detailVehicleHistory(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useVehiclesHistoryPorto(params?: VehicleHistoryPortoRequest) {
  const cache = queryClient.getQueryData([QUERY_VEHICLE_HISTORY_PORTO, params]);

  return useInfiniteQuery(
    [QUERY_VEHICLE_HISTORY_PORTO, params],
    ({ pageParam }) => {
      const req: VehicleHistoryQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return vehicleHistoryPorto(req);
    },
    {
      retry: 0,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled: params?.licensePlate?.length === 7 && !cache,
      onError(error) {
        const err = error as AxiosError;

        if (!!err.response?.data.entityName) {
          return notification.error({
            message: 'Erro ao buscar informações da placa',
            description: err.response?.data.entityName,
          });
        }

        notificationError(error);
      },
    },
  );
}
